import Common from '../common'
var Js = Common('personal')
export default {
	name: 'personal',
	mixins: [Js],
	components: {},
	data() {
		return {
			fields: [{
					key: 'id',
					label: '司机ID',
					application: [],
					componentName: 'sls-input',
					listType: '',
					width: 50
				},
				{
					key: 'user_no',
					label: '司机NO',
					application: [],
					componentName: 'sls-input',
					listType: ''
				},
				{
					key: 'login_name',
					label: '司机登录名',
					application: ['编辑账号', '添加账号'],
					componentName: 'sls-input',
					listType: 'normal',
					placeholder: '请输入司机登录名',
					header_search: {
						componentName: 'sls-input',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请输入司机登录名',
						changeFunc: function(e, self) {
							if (e.target._value) {
								self.searchItem.login_name = ['LIKE', ['%' + e.target._value + '%']];
							} else {
								delete self.searchItem.login_name;
							};
							self.initMainData();
						},
					}
				},
				{
					key: 'password',
					label: '司机密码',
					application: ['编辑账号', '添加账号'],
					componentName: 'sls-input',
					dialog: {
						type: 'password'
					}
				},
				{
					key: "name",
					label: '司机姓名',
					application: ['添加信息', '编辑信息'],
					componentName: 'sls-input',
					listType: 'normal',
					formatter: function(val) {
						return val.info.name
					},
					placeholder: '请输入司机姓名',
					header_search: {
						componentName: 'sls-input',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请输入司机姓名',
						changeFunc: function(e, self) {
							if (e.target._value) {
								self.UserInfo.searchItem.name = ['LIKE', ['%' + e.target._value + '%']]
							} else {
								delete self.UserInfo.searchItem.name
							};
							self.beforeSearch('UserInfo');
						},
					},

				},
				{
					key: "phone",
					label: '司机电话',
					application: ['添加信息', '编辑信息'],
					componentName: 'sls-input',
					listType: 'normal',
					formatter: function(val) {
						return val.info.phone
					},
					header_search: {
						componentName: 'sls-input',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请输入司机电话',
						changeFunc: function(e, self) {
							if (e.target._value) {
								self.UserInfo.searchItem.phone = ['LIKE', ['%' + e.target._value + '%']]
							} else {
								delete self.UserInfo.searchItem.phone
							};
							self.beforeSearch('UserInfo');
						},
					},
				},
				{
					key: "status",
					label: '状态',
					application: ['编辑账号'],
					componentName: 'sls-select',
					optionsName: 'statusOptions',
					defaultProps: {
						label: 'text',
						value: 'value',
					},
					formatter: function(val) {
						if (val.status == 1) {
							return '启用';
						} else {
							return '关闭';
						};
					}
				},
				{
					key: 'create_time',
					label: '创建时间',
					listType: 'normal',
					placeholder: '请选择创建时间',
					width:180
				},
				{
					label: '操作',
					listType: 'deal',
					width: 200
				},
			],
			// 按钮配置
			btn_info: [

				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						if (data) {
							return JSON.stringify(data.info) != '[]' ? '编辑信息' : '添加信息'
						} else {
							return ['编辑信息', '添加信息'];
						}

					},
					func: {
						apiName: function(self) {
							return JSON.stringify(self.formData.info) != "[]" ? "api_userInfoUpdate" : "api_userInfoAdd"
						},

						formData: function(self) {
							var data = self.formData.info;
							return data
						},

						postData: function(self) {
							if (self.btnName == '编辑信息') {
								var postData = {
									searchItem: {
										id: self.originFormData.info.id,
										user_no: self.originFormData.info.user_no
									},
									data: self.submitData
								}
							} else if (self.btnName == '添加信息') {
								var postData = {
									data: self.submitData
								};
							};
							postData.data.user_no = self.originFormData.user_no;

							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return '编辑账号'
					},
					func: {
						apiName: function(self) {
							return "api_userUpdate"
						},
						formData: function(self) {

							return self.formData
						},
						postData: function(self) {
							var postData = {
								searchItem: {
									id: self.formData.id,
									user_no: self.formData.user_no,
								},
								data: self.submitData
							}
							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return '管理权限sss'
					},
					isHide: function(self) {
						if (self.formData.user_no == self.$store.getters.getUserinfo.user_no && self.$store.getters.getUserinfo.primary_scope <
							60) {
							return true;
						} else {
							return false;
						};
					},
					funcType: 'func',
					func: {
						func: function(self) {
							console.log('self.originFormData', self.originFormData);

							self.$router.push({
								path: '/home/access',
								name: '权限管理',
								params: {
									defaultChecked: self.originFormData.passage_array,
									user_no: self.originFormData.user_no,
									primary_scope: self.originFormData.primary_scope,
									path: '/home/staff',
								}
							});

						},
						postData: function(self) {
							var postData = {
								searchItem: {
									id: self.formData.id,
								},
								data: data
							};
							return postData;
						},
					},
				},
				{
					type: 'danger',
					icon: 'delete',
					size: 'mini',
					funcType: 'submit',
					position: 'header',
					text: function(data) {
						return '删除选中'
					},
					func: {

						apiName: function(self) {
							return "api_userUpdate"
						},

						postData: function(self) {
							var deleteArray = [];
							for (var i = 0; i < self.selectionArray.length; i++) {
								deleteArray.push(self.selectionArray[i].id);
							};
							var postData = {
								searchItem: {
									id: ['in', deleteArray],
									user_type: 1
								},
								data: {
									status: -1
								}
							};
							return postData;
						}

					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'header',
					text: function(data) {
						return '添加账号'
					},
					func: {
						apiName: function(self) {
							return "api_userAdd"
						},
						formData: function(self) {
							var data = {
								login_name: '',
								password: '',
							};
							return data
						},
						postData: function(self) {
							self.submitData.user_type = 1;
							self.submitData.behavior = 1;
							self.submitData.primary_scope = 30;
							var postData = {
								data: self.submitData
							};
							return postData;
						}
					},
				},
			],
			
			searchItem: {
				user_type: 1,
				behavior: 1
			},
			startSearchItem: {
				user_type: 1,
				behavior: 1
			},
			optionData: {
				labelOptions: [],
				statusOptions: [{
					text: '启用',
					value: 1
				}, {
					text: '禁用',
					value: -1
				}],
				behaviorUserOptions: [{
					text: '是',
					value: 0
				}, {
					text: '否',
					value: 1
				}],
				behaviorOptions: [{
						text: '开发',
						value: 1
					},
					{
						text: '销售',
						value: 2
					},
					{
						text: '运营',
						value: 3
					},
					{
						text: '人事/行政',
						value: 4
					},
					{
						text: '财务',
						value: 5
					},
				],
			},
			otherData: {},
			UserInfo: {
				tableName: 'UserInfo',
				searchItem: {},
				fixSearchItem: {
					status: 1
				},
				key: 'user_no',
				middleKey: 'user_no',
				condition: 'in',
			}

		}

	},

	mounted() {
		this.init()
	},
	computed: {
		token: function() {
			return this.$store.getters.getToken
		}
	},
	methods: {

		/**
		 * 初始化
		 */
		init() {
			this.initMainData()
		},

		/**
		 * 列表主函数
		 */
		async initMainData() {

			const self = this;
			const postData = {};
			postData.paginate = self.$$cloneForm(self.paginate);
			postData.token = self.$store.getters.getToken;
			if (self.searchItem) {
				postData.searchItem = self.$$cloneForm(self.searchItem)
			};
			if (JSON.stringify(self.getBefore) != "{}") {
				postData.getBefore = self.$$cloneForm(self.getBefore);
			};
			var res = await self.$$api_userGet({
				data: postData
			});

			self.mainData = res.info.data;
			console.log('self.mainData', self.mainData);
			self.paginate.count = res.info.total;

		},


	},


}



// WEBPACK FOOTER //
// ./src/views/user/personal.js